// @core/api/endpoints/team/create_role_delegation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateRoleDelegationRequest,
  RoleDelegationResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Create role delegation
 * Creates a new role delegation with the provided data. Returns the created resource.
 */
export async function CreateRoleDelegation(
  team_id: string,
  data: CreateRoleDelegationRequest,
  options?: RequestOptions
): Promise<RoleDelegationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/delegations`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<RoleDelegationResponse>(requestPath, data, requestOptions);
}
